import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, of, switchMap } from "rxjs";
import { UserService } from "src/app/shared/services/settings/user";
import { appEventActions } from "../../app-event";
import { userActions } from "./user.action";

@Injectable()
export class UserEffects {
    constructor(
        private actions$: Actions,
        private userService: UserService,
    ) {}

    create$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(userActions.create),
            switchMap((data) =>
                this.userService.create(data.data).pipe(
                    switchMap(() => {
                        data.onClose(true);

                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "User created successfully.",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    update$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(userActions.update),
            switchMap((data) =>
                this.userService.update(data.data, data.id).pipe(
                    switchMap(() => {
                        data.onClose(true);
                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "User updated successfully.",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });
}
